/**
 * NOVATUS Energie GmbH — Logo + kleiner Zusatz „Sales Pro · WP & PV“.
 * - `size`: sm | md | lg | xl   – steuert Bild-Höhe
 * - `compact`: nur Logo ohne Zusatz
 */
const LOGO_SRC = "/logo/novatus-energie.png?v=2";

export const NovatusLogo = ({ size = "lg", className = "", compact = false, variant = "" }) => {
  const sfx = variant ? `-${variant}` : "";
  const sizes = {
    sm: { h: 40, sub: "text-[10px]", gap: "gap-2" },
    md: { h: 56, sub: "text-[11px]", gap: "gap-3" },
    lg: { h: 72, sub: "text-[12px]", gap: "gap-3" },
    xl: { h: 120, sub: "text-[14px]", gap: "gap-4" },
  };
  const s = sizes[size] || sizes.lg;

  return (
    <div className={`inline-flex items-center ${s.gap} ${className}`} data-testid={`novatus-logo${sfx}`}>
      <img
        src={LOGO_SRC}
        alt="NOVATUS Energie GmbH"
        style={{ height: s.h, width: "auto", display: "block" }}
        className="flex-shrink-0 object-contain rounded-xl bg-black"
        draggable={false}
        data-testid={`novatus-logo-img${sfx}`}
      />
      {!compact && (
        <div
          className={`${s.sub} font-mono uppercase tracking-[0.2em] text-zinc-400 whitespace-nowrap leading-tight`}
          data-testid={`novatus-logo-sub${sfx}`}
        >
          Sales Pro
          <br />
          WP &amp; PV
        </div>
      )}
    </div>
  );
};
